import React from "react";
import "./LargePrompt.css";

export default function LargePrompt(props: {
  prompt: string;
  onChangeText: (text: string) => void;
}) {
  return (
    <div className="LargePromptContainer">
      <div className="LargePromptText">{props.prompt}</div>
      <div className="LargePromptInputContainer">
        <textarea
          className="LargePromptInput"
          onChange={(event) => props.onChangeText(event.target.value)}
        />
      </div>
    </div>
  );
}
